import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretToRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.834 0.966651C11.834 0.690509 11.6101 0.466651 11.334 0.466651C11.0578 0.466651 10.834 0.690509 10.834 0.966651L10.834 13.6333C10.834 13.9094 11.0578 14.1333 11.334 14.1333C11.6101 14.1333 11.834 13.9094 11.834 13.6333L11.834 0.966651ZM0.287959 13.3062C0.107656 13.5153 0.131044 13.8311 0.340199 14.0114C0.549353 14.1917 0.865069 14.1683 1.04537 13.9591L6.49955 7.63221C6.66112 7.44478 6.66129 7.16737 6.49995 6.97974L1.04704 0.638449C0.867001 0.429071 0.551312 0.405293 0.341935 0.585337C0.132559 0.765381 0.10878 1.08107 0.288823 1.29045L5.46105 7.30533L0.287959 13.3062Z",
		fill: "#212121"
	})
});
export default SvgCaretToRightIcon;
